module.exports = __webpack_public_path__ + "static/media/rating.ccd7729c.svg";